import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Badge } from "@/components/ui/badge";

export default function NotificationsMenu() {
  const [items, setItems] = useState([]);
  const load = async () => {
    try { const r = await api.get("/notifications"); setItems(r.data); } catch {}
  };
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);
  const unread = items.filter((i) => !i.read).length;
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notifications-button">
          <Bell className="w-5 h-5" />
          {unread > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-4 h-4 px-1 rounded-full bg-rose-500 text-white text-[10px] font-semibold flex items-center justify-center">
              {unread}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0 bg-white" align="end">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100">
          <div className="font-semibold text-sm">Notifications</div>
          <Button variant="ghost" size="sm" onClick={markAll} data-testid="mark-all-read-button" className="text-xs">
            <Check className="w-3 h-3 mr-1" /> Mark all read
          </Button>
        </div>
        <div className="max-h-96 overflow-auto scrollbar-thin divide-y divide-slate-100">
          {items.length === 0 && <div className="p-6 text-center text-sm text-slate-500">No notifications</div>}
          {items.map((n) => (
            <div key={n.id} className={`px-4 py-3 ${n.read ? "" : "bg-emerald-50/40"}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="text-sm font-medium text-slate-900">{n.title}</div>
                <Badge variant="outline" className="text-[10px]">{n.kind.replace("_"," ")}</Badge>
              </div>
              {n.body && <div className="text-xs text-slate-600 mt-1">{n.body}</div>}
              <div className="text-[10px] text-slate-400 mt-1">{new Date(n.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
